import React from "react";
import styled from "styled-components";
import SnapshotGenerator from '../classes/SnapshotGenerator';

const CreatorPreviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Button = styled.button`
    width: 100%;
    text-align: center;
`;

const Img = styled.img`
    width: 100%;
`

export default class CreatorPreview extends React.Component{

    componentDidMount(){
        SnapshotGenerator.renderPreview([window.json_projects[this.props.clickedTabIndex]]);
    }

    render(){        
        return(
            <CreatorPreviewWrapper>
                <Img src='' id={`konvaPreview`}></Img>
                <Button
                    className="btn btn-primary"
                    onClick={this.props.closeModal}
                >
                        {this.props.closeButtonText}
                </Button>
            </CreatorPreviewWrapper>
        )
    };
}